import { parsePhoneNumberWithError, parsePhoneNumberFromString } from "libphonenumber-js";

/**
 *
 * @param {string} value
 * @param {*} countryCode
 * @returns
 */
const validatePhone = (value, countryCode = "") => {
  const errorMessage = "error_phone_number_correct";
  try {
    // search for non-numeric letters, to invalidate
    const foundLetters = value?.match(/[^0-9+]/g);
    if (foundLetters?.length > 0) return errorMessage;
    let isValid = null;
    if (countryCode) {
      isValid = parsePhoneNumberWithError(value?.replace(/\s+/g, ""), countryCode).isValid();
    } else {
      const phone = parsePhoneNumberFromString(value);
      if (!phone) return errorMessage;
      isValid = phone.isValid();
      countryCode = phone.country || null;
    }

    return isValid || errorMessage;
  } catch (error) {
    return errorMessage;
  }
};

export default validatePhone;
